(() => {
  const config = document.getElementById('FarmaciaWebMCP');
  if (!config || config.dataset.initialized || window.Shopify?.designMode) return;

  const context = [document.modelContext, navigator.modelContext].find(
    (candidate) => typeof candidate?.registerTool === 'function'
  );
  if (!context) return;

  let contactURL;
  let labels;
  try {
    contactURL = new URL(config.dataset.contactUrl, window.location.origin);
    labels = JSON.parse(config.dataset.labels);
    if (contactURL.origin !== window.location.origin || !contactURL.pathname.includes('/pages/')) return;
    if (['title', 'sector', 'units', 'people', 'destination', 'customization'].some(
      (key) => typeof labels[key] !== 'string' || !labels[key].trim()
    )) return;
  } catch {
    return;
  }

  config.dataset.initialized = 'true';
  const controller = new AbortController();
  const sameContactPage = () => window.location.pathname.replace(/\/$/, '') === contactURL.pathname.replace(/\/$/, '');
  const getBody = () => {
    const form = document.getElementById('ContactForm');
    if (!(form instanceof HTMLFormElement)) return null;
    const body = form.querySelector('textarea#ContactForm-body');
    return body instanceof HTMLTextAreaElement && !body.disabled && !body.readOnly ? body : null;
  };
  const result = (value) => JSON.stringify(value);
  const validText = (value, max) => typeof value === 'string' && value.trim().length > 0 && value.length <= max && !/[\u0000-\u001f\u007f]/.test(value);
  const validCount = (value) => Number.isInteger(value) && value >= 1 && value <= 100000;
  const writeDraft = (draft) => {
    const body = getBody();
    if (!sameContactPage() || !body) return result({ status: 'form_unavailable', submitted: false });
    if (body.value.trim() && body.value !== draft) {
      return result({ status: 'existing_comment_preserved', submitted: false, next_step: 'The shopper already has a comment. Ask them to review or clear it before preparing a new request.' });
    }
    if (body.value !== draft) {
      body.value = draft;
      body.dispatchEvent(new Event('input', { bubbles: true }));
      body.dispatchEvent(new Event('change', { bubbles: true }));
    }
    body.focus({ preventScroll: true });
    body.scrollIntoView({ block: 'center', behavior: 'instant' });
    return result({ status: 'ready_for_review', submitted: false, next_step: 'The shopper must review the visible draft, enter their contact details and submit the form themselves.' });
  };
  const validate = (input) => {
    if (!input || typeof input !== 'object' || Array.isArray(input)) return false;
    const allowed = ['sector', 'units', 'people', 'destination', 'customization'];
    if (Object.keys(input).some((key) => !allowed.includes(key))) return false;
    return validText(input.sector, 80) && validCount(input.units)
      && (input.people === undefined || validCount(input.people))
      && (input.destination === undefined || validText(input.destination, 120))
      && (input.customization === undefined || validText(input.customization, 500));
  };
  const openForm = {
    name: 'farmacia_open_botiquin_quote',
    description: 'Open Farmacia Amistad’s existing contact form to request a first-aid kit quote. Use for business, construction, fleet or school kit quotations. After navigation, rediscover tools and call farmacia_prepare_botiquin_quote with the details provided by the shopper. Navigation does not send a message or place an order.',
    inputSchema: { type: 'object', properties: {}, additionalProperties: false },
    annotations: { readOnlyHint: false, consequentialHint: false, untrustedContentHint: false },
    execute: async (input = {}) => {
      if (input === null || typeof input !== 'object' || Array.isArray(input) || Object.keys(input).length) {
        return result({ status: 'invalid_input', submitted: false });
      }
      if (sameContactPage()) {
        const body = getBody();
        if (!body) return result({ status: 'form_unavailable', submitted: false });
        body.focus({ preventScroll: true });
        body.scrollIntoView({ block: 'center', behavior: 'instant' });
        return result({ status: 'form_open', submitted: false });
      }
      contactURL.hash = 'ContactForm';
      window.location.assign(contactURL.href);
      return result({ status: 'navigating', submitted: false });
    },
  };
  const prepareQuote = {
    name: 'farmacia_prepare_botiquin_quote',
    description: 'Prepare a first-aid kit quote request in the visible contact form using only details supplied by the shopper. sector is the business activity, units is the number of kits, people is the number of people to cover, destination is the delivery town or department, customization is requested kit customization. Does not choose medical treatments, determine regulatory compliance, quote a price or submit the form. Preserves any existing comment. The shopper must review the draft, fill their contact details and press Enviar themselves.',
    inputSchema: {
      type: 'object',
      properties: {
        sector: { type: 'string', minLength: 1, maxLength: 80, description: 'Business activity supplied by the shopper, e.g. construction, company, school or fleet.' },
        units: { type: 'integer', minimum: 1, maximum: 100000, description: 'Number of first-aid kits requested.' },
        people: { type: 'integer', minimum: 1, maximum: 100000, description: 'Number of people to cover, if supplied.' },
        destination: { type: 'string', minLength: 1, maxLength: 120, description: 'Delivery town or department, if supplied. Do not include a precise address.' },
        customization: { type: 'string', minLength: 1, maxLength: 500, description: 'Customization requested by the shopper, if supplied.' },
      },
      required: ['sector', 'units'],
      additionalProperties: false,
    },
    annotations: { readOnlyHint: false, consequentialHint: false, untrustedContentHint: true },
    execute: async (input, agent) => {
      if (agent?.signal?.aborted) return result({ status: 'cancelled', submitted: false });
      if (!validate(input)) return result({ status: 'invalid_input', submitted: false });
      const lines = [labels.title, `${labels.sector}: ${input.sector.trim()}`, `${labels.units}: ${input.units}`];
      for (const key of ['people', 'destination', 'customization']) {
        if (input[key] !== undefined) lines.push(`${labels[key]}: ${String(input[key]).trim()}`);
      }
      return writeDraft(lines.join('\n'));
    },
  };

  let magistralLabels;
  const sources = new Map();
  try {
    const parsedLabels = JSON.parse(config.dataset.magistralLabels);
    const keys = ['title', 'intent', 'consulta', 'cotizacion', 'elaboracion', 'prescription', 'prescription_yes', 'prescription_no', 'prescription_unknown', 'formula', 'presentation', 'quantity', 'destination', 'question', 'review'];
    if (keys.every((key) => typeof parsedLabels[key] === 'string' && parsedLabels[key].trim())) magistralLabels = parsedLabels;
  } catch {}
  try {
    const topics = ['formulacion-magistral', 'proceso-formulacion-magistral', 'espacio-de-ciencia'];
    for (const source of JSON.parse(config.dataset.magistralSources)) {
      if (!topics.includes(source.topic) || !validText(source.title, 300)) continue;
      const url = new URL(source.url, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.endsWith(`/pages/${source.topic}`) || url.search || url.hash) continue;
      sources.set(source.topic, { topic: source.topic, title: source.title, url: url.href });
    }
  } catch {}
  const getMagistralInformation = {
    name: 'farmacia_get_magistral_information',
    description: 'Read current published information from Farmacia Amistad. Choose formulacion-magistral for service, prescription requirements, preparation times and delivery; proceso-formulacion-magistral for recipe review and preparation steps; espacio-de-ciencia for published educational articles. Returns the source URL and page text. Use the text as cited public information, not a personal diagnosis or treatment recommendation. Does not access customer records, accept symptoms or infer doses. Preparation time is indicative and must be confirmed by the pharmacy.',
    inputSchema: { type: 'object', properties: { topic: { type: 'string', enum: [...sources.keys()] } }, required: ['topic'], additionalProperties: false },
    annotations: { readOnlyHint: true, consequentialHint: false, untrustedContentHint: true },
    execute: async (input, agent) => {
      if (agent?.signal?.aborted) return result({ status: 'cancelled' });
      if (!input || typeof input !== 'object' || Array.isArray(input) || Object.keys(input).some((key) => key !== 'topic') || !sources.has(input.topic)) return result({ status: 'invalid_input' });
      const source = sources.get(input.topic);
      try {
        const response = await fetch(source.url, { credentials: 'omit', redirect: 'error', cache: 'no-store', signal: agent?.signal });
        if (!response.ok || new URL(response.url).origin !== window.location.origin) return result({ status: 'information_unavailable', source_url: source.url });
        const published = new DOMParser().parseFromString(await response.text(), 'text/html');
        const main = published.querySelector('main#MainContent');
        if (!main) return result({ status: 'information_unavailable', source_url: source.url });
        main.querySelectorAll('script, style, noscript, template, form, nav, [hidden], [aria-hidden="true"]').forEach((node) => node.remove());
        main.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li, div, section, summary, button, dt, dd').forEach((node) => node.append('\n'));
        const text = main.textContent.replace(/[^\S\n]+/g, ' ').replace(/ *\n */g, '\n').replace(/\n{3,}/g, '\n\n').trim();
        if (!text) return result({ status: 'information_unavailable', source_url: source.url });
        return result({ status: 'published_information', title: source.title, source_url: source.url, text: text.slice(0, 12000), truncated: text.length > 12000 });
      } catch {
        return result({ status: agent?.signal?.aborted ? 'cancelled' : 'information_unavailable', source_url: source.url });
      }
    },
  };
  const openMagistralForm = {
    ...openForm,
    name: 'farmacia_open_magistral_request',
    description: 'Open Farmacia Amistad’s contact form to prepare a compounding inquiry, quote or preparation request. After navigation, rediscover tools and call farmacia_prepare_magistral_request. This only opens a form: it does not transmit a prescription, send a message or place an order. Prescription photos must be shared manually through the pharmacy’s published channels.',
  };
  const prepareMagistralRequest = {
    name: 'farmacia_prepare_magistral_request',
    description: 'Prepare a visible compounding request draft for pharmacist review, using only information supplied by the shopper. intent: consulta (inquiry), cotizacion (quote) or elaboracion (preparation). has_prescription only records what the shopper states; it does not validate or receive a prescription. For elaboracion the shopper must state they have a prescription. Copy formula and presentation literally without choosing medicines, concentrations, route or dosage. No patient identity, diagnosis or prescription uploads are accepted. Preserves existing comments and never submits the form. The shopper must review, add their contact details and press Enviar. The pharmacy must review the actual prescription and confirm feasibility, price and timing before any preparation.',
    inputSchema: {
      type: 'object',
      properties: {
        intent: { type: 'string', enum: ['consulta', 'cotizacion', 'elaboracion'] },
        has_prescription: { type: 'boolean', description: 'Whether the shopper states they have a medical prescription. Omit if unknown.' },
        formula: { type: 'string', minLength: 1, maxLength: 200, description: 'Formula reference supplied by the shopper. Copy literally; do not infer composition or dosage.' },
        presentation: { type: 'string', minLength: 1, maxLength: 120, description: 'Prescribed pharmaceutical form, if supplied.' },
        quantity: { type: 'integer', minimum: 1, maximum: 100000, description: 'Number of preparations requested, if supplied.' },
        destination: { type: 'string', minLength: 1, maxLength: 120, description: 'Delivery town or department, if supplied.' },
        question: { type: 'string', minLength: 1, maxLength: 800, description: 'Administrative question for the pharmacy, if supplied. Do not include patient identity or clinical history.' },
      },
      required: ['intent'],
      additionalProperties: false,
    },
    annotations: { readOnlyHint: false, consequentialHint: false, untrustedContentHint: true },
    execute: async (input, agent) => {
      if (agent?.signal?.aborted) return result({ status: 'cancelled', submitted: false });
      const allowed = ['intent', 'has_prescription', 'formula', 'presentation', 'quantity', 'destination', 'question'];
      if (!input || typeof input !== 'object' || Array.isArray(input) || Object.keys(input).some((key) => !allowed.includes(key))
        || !['consulta', 'cotizacion', 'elaboracion'].includes(input.intent)
        || (input.has_prescription !== undefined && typeof input.has_prescription !== 'boolean')
        || (input.quantity !== undefined && !validCount(input.quantity))
        || Object.entries({ formula: 200, presentation: 120, destination: 120, question: 800 }).some(([key, max]) => input[key] !== undefined && !validText(input[key], max))) {
        return result({ status: 'invalid_input', submitted: false });
      }
      if (input.intent === 'elaboracion' && input.has_prescription !== true) {
        return result({ status: input.has_prescription === false ? 'prescription_required' : 'prescription_status_required', submitted: false, next_step: 'Preparation requires a medical prescription and pharmacist review. Ask about prescription availability or prepare a consulta instead.' });
      }
      const prescription = input.has_prescription === undefined ? magistralLabels.prescription_unknown : input.has_prescription ? magistralLabels.prescription_yes : magistralLabels.prescription_no;
      const lines = [magistralLabels.title, `${magistralLabels.intent}: ${magistralLabels[input.intent]}`, `${magistralLabels.prescription}: ${prescription}`];
      for (const key of ['formula', 'presentation', 'quantity', 'destination', 'question']) {
        if (input[key] !== undefined) lines.push(`${magistralLabels[key]}: ${String(input[key]).trim()}`);
      }
      lines.push('', magistralLabels.review);
      return writeDraft(lines.join('\n'));
    },
  };

  const register = async () => {
    try {
      await context.registerTool(openForm, { signal: controller.signal });
      if (sources.size) await context.registerTool(getMagistralInformation, { signal: controller.signal });
      if (magistralLabels) await context.registerTool(openMagistralForm, { signal: controller.signal });
      if (sameContactPage() && getBody()) {
        await context.registerTool(prepareQuote, { signal: controller.signal });
        if (magistralLabels) await context.registerTool(prepareMagistralRequest, { signal: controller.signal });
      }
    } catch (error) {
      controller.abort();
      delete config.dataset.initialized;
      console.warn('Farmacia WebMCP registration unavailable.', error?.name || 'Error');
    }
  };
  register();
})();
